import styled, {css} from "styled-components";
import {parseInputSize, parseSize, transformSize} from "../../../common/generic-react.functions.js";
import {LabelContainer} from "../label/label.styles.js";
function withAndSize({
  width,
  size
}) {
  if (width) {
    return css(["", ""], width && `width: ${width};`);
  } else if (size) {
    return css(["", ""], size && `width: ${parseInputSize(size)};`);
  }
  return css([""]);
}
export const InputContainer = styled.div.withConfig({
  displayName: "inputstyles__InputContainer",
  componentId: "sc-1gm843l-0"
})(["", " ", " ", " ", "{", "}", ",input{", " width:100%;", " ", "}.input-container{", " &__prepend{", "}&__append{", "}}input{", " color:", ";background-color:", ";", " ", " ", "}.input__error,.input__hint{", " font-size:", ";}.input__error{", "}.input__hint{", "}"], {
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "column",
  flexWrap: "wrap",
  overflowWrap: "break-word"
}, ({
  width,
  size
}) => withAndSize({
  width,
  size
}), ({
  disabled
}) => disabled && {
  opacity: "0.5",
  cursor: "not-allowed"
}, LabelContainer, ({
  errorMessage
}) => errorMessage && {
  color: "var(--errorColor)"
}, LabelContainer, {
  paddingLeft: "0px",
  paddingRight: "0px"
}, ({
  readOnly
}) => readOnly && {
  cursor: "default"
}, ({
  disabled
}) => disabled && {
  cursor: "not-allowed"
}, {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  position: "relative",
  width: "100%"
}, {
  paddingRight: "0.5rem"
}, {
  paddingLeft: "0.5rem"
}, {
  paddingTop: "0.75rem",
  paddingBottom: "0.75rem",
  paddingLeft: "1.25rem",
  paddingRight: "1.25rem",
  outline: "2px solid transparent",
  outlineOffset: "2px",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "var(--tertiaryColor)",
  width: "100%"
}, ({
  color
}) => color, ({
  bgColor
}) => bgColor, ({
  disabled,
  readOnly
}) => !disabled && !readOnly && {
  cursor: "text"
}, ({
  errorMessage
}) => errorMessage && {
  borderWidth: "1px",
  borderColor: "var(--errorColor)"
}, ({
  hasReset
}) => hasReset && {
  paddingRight: "2.25rem"
}, {
  marginTop: "0.25rem"
}, parseSize(transformSize("md", -1)), {
  color: "var(--errorColor)"
}, {
  opacity: "0.25"
});
export const InputResetContainer = styled.div.withConfig({
  displayName: "inputstyles__InputResetContainer",
  componentId: "sc-1gm843l-1"
})(["", " &:hover{", "}"], {
  display: "inline-flex",
  alignItems: "center",
  position: "absolute",
  top: "0px",
  bottom: "0px",
  right: "0.5rem",
  opacity: "0.3"
}, {
  opacity: "1"
});
